import React, { useEffect, useCallback, useState } from 'react';

import { useLocation, useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  downloadReport,
  getAllReports,
} from '../../data/store/portfolio/portfolioActions';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { v4 as uuidv4 } from 'uuid';

import { Row, Layout, Col, Button } from 'antd';
import ReportDone from './ReportDone';
import CustomSortIcon from '../../components/CustomSortIcon/CustomSortIcon';
import { ReactComponent as Download } from './img/download-orange-icon.svg';

import { textSort } from '../../helpers/textSort';

import CustomTable from '../../components/CustomTable/CustomTable';
import './style.scss';

const { Header } = Layout;

const Report = ({ userId }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const state = location.state;
  const { t } = useTranslation('');

  const [tableColumns, setTableColumns] = useState();

  const reports = useSelector((state) => state.portfolioReducer.reports.list);
  const { isReportOptPrepare, isLoading } = useSelector(
    (state) => state.portfolioReducer,
  );

  let fetch = false;
  useEffect(() => {
    if (userId && !fetch) {
      fetch = true;
      dispatch(getAllReports(userId));
    }
  }, [userId]);

  const getReportName = useCallback(
    (id) => {
      return reports.find((i) => i.ID === id)?.name || '';
    },
    [reports],
  );

  useEffect(() => {
    if (reports?.length) {
      const defaultColumns = [
        {
          title: t('NAME'),
          dataIndex: 'name',
          className: 'holdings-instrument first-column-p24',
          width: '70%',
          sorter: (a, b) => textSort(a.name, b.name),
          sortIcon: (props) => <CustomSortIcon {...props} />,
        },
        {
          title: t('CREATED_DATE'),
          dataIndex: 'createdAt',
          className: 'holdings-data',
          width: '15%',
          align: 'center',
          defaultSortOrder: 'descend',
          render: (value) => {
            return dayjs(value).format('YYYY-MM-DD');
          },
          sorter: (a, b) => textSort(a.createdAt, b.createdAt),
          sortIcon: (props) => <CustomSortIcon {...props} />,
        },
        {
          title: t('ACTION'),
          dataIndex: '',
          className: 'holdings-data',
          align: 'center',
          width: '15%',
          render: (_, record) => {
            return (
              <Button
                className="download-btn"
                icon={<Download />}
                iconPosition="end"
                onClick={onDownload(record.ID)}
              >
                {t('DOWNLOAD')}
              </Button>
            );
          },
        },
      ];
      setTableColumns(defaultColumns);
    }
  }, [reports]);

  const closeTooltip = () => {
    history.replace(location.pathname, {});
  };
  const onDownload = (reportId) => () => {
    dispatch(downloadReport(reportId));
    closeTooltip();
  };

  return (
    <div className="instrument-wrapper">
      <div className="">
        <Header className="headerStyle suggested">
          <h1 className="suggested-portfolios-title">{t('DOCUMENTS')}</h1>
          <Row className="suggested-tabs-wrapper">
            <Col className="tabs-tab-wrapper" span={18}>
              <Button type="text" className={'overview-btn ant-btn-active'}>
                {t('REPORTS')}
              </Button>
            </Col>
          </Row>
        </Header>
      </div>
      <div className="client portfolio-table suggestions-table">
        <CustomTable
          rowKey={() => uuidv4()}
          loading={isLoading}
          dataSource={reports}
          columns={tableColumns}
          size="middle"
          pagination={false}
        />
      </div>
      {state?.key === 'create' && isReportOptPrepare !== null && (
        <ReportDone
          interval={65}
          isReportOptPrepare={isReportOptPrepare}
          getReportName={getReportName}
          closeTooltip={closeTooltip}
          downloadReport={onDownload}
        />
      )}
    </div>
  );
};

export default Report;

Report.propTypes = {
  userId: PropTypes.string,
};
